import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Bundle = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Bundle' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M17,14 L7,14 L17,14 Z M17,3 L23,3 L23,13 L17,13 M1,13 L1,17 L7,17 M17,17 L23,17 L23,13 M1,17 L1,21 L7,21 M23,17 L23,21 L17,21 M7,22 L17,22 L17,2 L7,2 L7,22 Z M7,13 L1,13 L1,3 L7,3' />
  </StyledIcon>
);
